module.exports = __webpack_public_path__ + "static/img/Desktop_Footer_Logo.c039334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop/landing/2024/Desktop_Footer_Logo.png
// module id = xNTn
// module chunks = 1